import React, { useEffect, useState } from "react";
import { getPowerBiReportToken } from "../../api";
import { IframeLayout } from "../../components/Layouts";
import { PowerBiContent } from "../../components/PageContent";
import { POWER_BI_URL_MAPPING } from "../../constants";
import { IPowerBiToken } from "../../constants/interface";

export const DigitalUserExperience = () => {
  const [powerBiToken, setPowerBiToken] = useState<IPowerBiToken>({
    embed_token: "",
    embed_url: "",
    report_id: "",
    token_id: "",
    token_expiration: "",
    report_name: "",
  });

  useEffect(() => {
    getPowerBiReportToken(POWER_BI_URL_MAPPING.decibel).then((token) => setPowerBiToken(token));
  }, []);

  // Usage tracking

  return (
    <IframeLayout hasFilter={false}>
      <PowerBiContent reportId="decibel" token={powerBiToken} showPagePane={false} />
    </IframeLayout>
  );
};
